import { FunctionComponent } from 'react';
import styled from 'styled-components';

import { DIRECTION } from '@/types/common';

interface ChevronProps {
  direction?: DIRECTION;
  width?: string | number;
  height?: string | number;
  strokeWidth?: string | number;
  className?: string;
  color?: string;
}

const Chevron: FunctionComponent<ChevronProps> = ({
  direction = DIRECTION.BOTTOM,
  strokeWidth = 1.5,
  width = 16,
  height = 9,
  className,
  color = 'black',
}) => {
  return (
    <ChevronSVG
      className={className}
      direction={direction}
      width={width}
      height={height}
      viewBox='0 0 16 9'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15 1L8 8L1 0.999999'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </ChevronSVG>
  );
};

export default Chevron;

const ChevronSVG = styled.svg<{ direction: DIRECTION }>`
  transition: transform 0.1s linear;
  transform: rotate(
    ${({ direction }) =>
      direction === DIRECTION.TOP
        ? 180
        : direction === DIRECTION.RIGHT
          ? -90
          : direction === DIRECTION.LEFT
            ? 90
            : 0}deg
  );
`;
